import { ReactNode } from 'react';
import { Card } from './Card';

interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  tone?: 'brand' | 'warning' | 'critical' | 'info';
  onClick?: () => void;
}

const toneClasses: Record<NonNullable<StatCardProps['tone']>, string> = {
  brand: 'bg-brand-light text-brand-700',
  warning: 'bg-amber-50 text-amber-600',
  critical: 'bg-red-50 text-critical',
  info: 'bg-blue-50 text-info',
};

/** Tarjeta de estadistica presionable, usada en el Home / Dashboard. */
export function StatCard({ icon, label, value, tone = 'brand', onClick }: StatCardProps) {
  return (
    <Card pressable={!!onClick} onClick={onClick} className="flex flex-col gap-3">
      <div className={['flex h-11 w-11 items-center justify-center rounded-xl', toneClasses[tone]].join(' ')}>
        {icon}
      </div>
      <div>
        <p className="break-words text-lg font-bold leading-tight text-ink-900 sm:text-2xl">{value}</p>
        <p className="mt-1.5 break-words text-sm text-ink-500">{label}</p>
      </div>
    </Card>
  );
}

export function KpiCard({ title, value, delta, tone = 'brand' }: { title: string; value: string; delta?: string; tone?: StatCardProps['tone'] }) {
  return (
    <Card className="flex flex-col gap-1">
      <p className="text-xs font-medium uppercase tracking-wide text-ink-400">{title}</p>
      <p className="text-xl font-bold text-ink-900">{value}</p>
      {delta && <span className={['text-xs font-medium', tone === 'critical' ? 'text-critical' : 'text-brand-600'].join(' ')}>{delta}</span>}
    </Card>
  );
}
